import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BlankCard from '../cards/BlankCard'

export default class UberFacts extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    uberFacts: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this._isMounted = false

    this.generateRandomFactIndex = () => Math.floor(Math.random() * this.props.uberFacts.length)

    this.state = {
      factIndex: this.generateRandomFactIndex(),
    }
  }

  componentDidMount() {
    this._isMounted = true
    if (this.factDom) {
      setInterval(() => {
        if(this._isMounted) this.setState({ factIndex:  this.generateRandomFactIndex()})
      }, 10000)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    const { factIndex } = this.state
    const { isMobile, uberFacts } = this.props

    return (
      <BlankCard
        delay={0.4}
        style={isMobile ? { maxWidth: 500, marginTop: -200 } : { maxWidth: 500, margin: '10px auto', marginTop: -100 }}
      >
        <div className="card-shadow" ref={(input) => { this.factDom = input }}>
            <h3>Did you know?</h3>
            <h5>{uberFacts[factIndex].fact}</h5>
        </div>
      </BlankCard>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ui/uberFacts/UberFacts.js